'use client';

import React, { useEffect } from 'react';
import useGlobalQuery from '@orgnc/core/hooks/useGlobalQuery';
import dailyMotionInjectorDetailsQuery from '@/lib/queries/dailyMotionInjectorDetailsQuery';

const DailymotionInjector: React.FC = () => {
  const { data: dailyMotionInjectorQuery } = useGlobalQuery(
    dailyMotionInjectorDetailsQuery
  );
  const injectAfter =
    dailyMotionInjectorQuery?.acfOptionsGeneral?.generalOptions
      ?.bmgDailymotionEmbedAfterParagraphs?.injectAfter ?? 2;
  const playlistId =
    dailyMotionInjectorQuery?.acfOptionsGeneral?.generalOptions
      ?.bmgDailymotionEmbedAfterParagraphs?.playlistId ?? '';
  /*  if (!playlistId) {
        return null;
      } */

  useEffect(() => {
    if (!playlistId) return;
    // Locate the main article element
    const article = document.querySelector('article');
    if (!article) return;

    // Get all valid paragraph blocks (excluding caption-style blocks)
    const allParagraphBlocks = Array.from(
      article.querySelectorAll('div.MuiTypography-root')
    );

    const validParagraphBlocks = allParagraphBlocks.filter((div) => {
      const isCaption = div.classList.contains('MuiTypography-caption');
      const paragraph = div.querySelector('p');
      return (
        !isCaption &&
        paragraph &&
        (paragraph.textContent || '').trim().length > 0
      );
    });

    if (validParagraphBlocks.length === 0) return;

    // Check if any other Dailymotion embed already exists on page
    const existingEmbeds = document.querySelectorAll(
      'iframe[src*="dailymotion.com/embed"]'
    );
    const autoplay = existingEmbeds.length > 0 ? '0' : '1';

    // Create a placeholder to be observed for lazy loading
    const placeholder = document.createElement('div');
    placeholder.className = 'dailymotion-video-placeholder';

    // Choose insertion point based on injectAfter (1-based index)
    const injectIndex = (injectAfter ?? 2) - 1;
    const injectionTarget =
      validParagraphBlocks[injectIndex] || article.lastElementChild;

    injectionTarget?.after(placeholder);

    // Lazy load the video iframe when placeholder enters the viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'dailymotion-video-container';
            videoWrapper.innerHTML = `
              <iframe
                title="Dailymotion Playlist"
                frameborder="0"
                width="100%"
                height="100%"
                allow="autoplay; fullscreen"
                allowfullscreen
                src="https://www.dailymotion.com/embed/playlist/${playlistId}?autoplay=${autoplay}"
              ></iframe>
            `;
            placeholder.replaceWith(videoWrapper);
            observer.disconnect(); // Stop observing after load
          }
        });
      },
      {
        rootMargin: '200px', // Trigger before fully in view for better UX
        threshold: 0.1,
      }
    );

    observer.observe(placeholder);

    // Inject CSS for styling the video container and placeholder
    const style = document.createElement('style');
    style.innerHTML = `
      .dailymotion-video-container {
        margin: 2rem 0;
        aspect-ratio: 16 / 9;
        width: 100%;
        max-width: 100%;
        height: auto;
      }

      .dailymotion-video-placeholder {
        margin: 2rem 0;
        height: 0;
        padding-top: 56.25%; /* Maintain 16:9 aspect ratio */
        width: 100%;
        background: #eee;
      }
    `;
    document.head.appendChild(style);
  }, [playlistId, injectAfter]);

  return null;
};

export default DailymotionInjector;
